<template>
  <div class="billing-wrap">
    <div class="consume-box">
      <div class="consume-item" v-if="$store.state.balancePay == 1">
        <p>{{ $store.state.currency }} {{ $util.convertCurrency(balance) }}</p>
        <p>{{$t('bill.availableCredit')}}</p>
        <div class="addbtn" @click="rechargeItem">{{$t('bill.addFunds')}}</div>
      </div>
      <div class="consume-item">
        <p>{{ $store.state.currency }} {{ $util.convertCurrency(log_money) }}</p>
        <p>{{$t('bill.month')}}</p>
      </div>
    </div>
    <!--
    <div class="payment-wrap">
      <div class="title">
        <p>Payment Methods</p>

        <el-button class="add" type="primary" @click="addPayment">
          Add Payment Method
        </el-button>
      </div>
      <div class="payment-list">
        <template  v-for="(item, index) in cardList">
        <div :class="['payment-item', item.status==4 ? ' locked-card' : '', item.isDefault == 1 ? ' default-payment' : '']">
          <div class="payment-left">
            <div class="imgbox">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-Pay_Visa" v-if="item.cardName == 'visa'"></use>
                <use xlink:href="#icon-Pay_Mastercard" v-if="item.cardName == 'mastercard'"></use>
                <use xlink:href="#icon-Pay_Express" v-if="item.cardName == 'express'"></use>
                <use xlink:href="#icon-Pay_UnionPay" v-if="item.cardName == 'unionPay'"></use>
              </svg>
            </div>
            <div class="payment-card">
              <p>{{ item.displayName }}</p>
              <ul>
                <li>{{ item.cardNumber }}</li>
                <li class="cardExpires">Expires</li>
                <li>06/26</li>
                <li class="green cardStatus" v-if="item.status == 1">Available</li>
                <li class="orange cardStatus" v-if="item.status == 2">Expiring Soon</li>
                <li class="red cardStatus" v-if="item.status == 3">Expired</li>
                <li class="red cardStatus" v-if="item.status == 4">No Available</li>
              </ul>
            </div>
          </div>
          <div class="payment-right">
            <el-dropdown>
              <span :class="['el-dropdown-link el-icon-more more ', item.status == 1 ? 'green' : '', item.status == 2 ? 'orange' : '', (item.status == 3 || item.status == 4) ? 'red' : '']"></span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item @click.native="makePayment(item)" :disabled="item.status == 3 || item.status == 4">
                  Make a Payment
                </el-dropdown-item>
                <el-dropdown-item @click.native="defaultPayment" :disabled="item.isDefault == 1 || item.status == 3 || item.status == 4">
                  Make Default
                </el-dropdown-item>
                <el-dropdown-item @click.native="editPayment" :disabled="item.status == 3 || item.status == 4">
                  Edit
                </el-dropdown-item>
                <el-dropdown-item @click.native="delPayment" :disabled="item.isDefault == 1" >
                  Delete
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </template>
      </div>
    </div>
    -->

    <div class="billing-table">
      <div class="billing-tab-head clearfix">
        <div class="tab-tool">
          <el-radio-group v-model="tabPosition">
            <el-radio-button label="1">{{$t('bill.history')}}</el-radio-button>
            <el-radio-button label="2">{{$t('bill.order')}}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="database-tab clearfix">
          <div class="database-tab-right">
            <div class="picker-box">
              <el-date-picker
                format="yyyy/MM/dd"
                v-model="date"
                type="daterange"
                :start-placeholder="$t('bill.startDate')"
                :end-placeholder="$t('bill.endDate')"
                placeholder="MM / DD / YYYY"
              >
              </el-date-picker>
            </div>
            <div class="search-box">
              <el-input
                :placeholder="$t('bill.searchNumber')"
                prefix-icon="el-icon-search"
                v-model="keyword"
              >
                <template slot="append"
                  ><span @click="search">{{$t('bill.search')}}</span></template
                >
              </el-input>
            </div>
            <div class="download" @click="download">
              <el-tooltip
                class="item"
                effect="light"
                :content="$t('bill.download')"
                placement="bottom-end"
              >
                <el-button icon="el-icon-download"></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <TabHistory v-show="tabPosition == 1" ref="log" />
      <TabOrder v-show="tabPosition == 2" ref="order" />

      <!-- 付款弹窗 -->
      <MakePayment ref="paymentmodal"/>

      <!-- 编辑付款 -->
      <EditPay ref="editmodal" />

      <!-- 删除 -->
      <DeleteCard ref="delmodal" />

      <!-- 默认付款方式 -->
      <MakeDefault ref="defaultmodla" />

      <!-- 添加付款方式 -->
      <AddMethod ref="addmodal" />

      <!--  -->
      <Recharge ref="rechargeModal" @getMoneyList="updateMoneyList"/>
    </div>
  </div>
</template>
<script>
import TabHistory from "./TabHistory";
import TabOrder from "./TabOrder";
import MakePayment from "@/components/user/Recharge";
import EditPay from "@/components/user/EditPay";
import DeleteCard from "@/components/user/DeleteCard";
import MakeDefault from "@/components/user/MakeDefault";
import AddMethod from "@/components/user/AddMethod";
import Recharge from "@/components/user/Recharge";
export default {
  inject:['reload'],
  data() {
    return {
      keyword:'',
      type: 'history',
      balance: 0,
      log_money: '',
      date: '',
      tabPosition: 1,
      cardList: [
        {
          cardId: 1,
          cardName: 'visa',
          displayName:  'VISA',
          cardNumber: "532 748 326 7238 842",
          status: 1,//正常
          isDefault: 1,
        },
        {
          cardId: 2,
          cardName: 'mastercard',
          displayName: 'MasterCard',
          cardNumber: "532 748 326 7238 842",
          status: 2,//即将过期
          isDefault: 0,
        },
        {
          cardId: 3,
          cardName: 'express',
          displayName: 'American Express',
          cardNumber: "532 748 326 7238 842",
          status: 3,//已过期
          isDefault: 0,
        },
        {
          cardId: 4,
          cardName: 'unionPay',
          displayName: 'UnionPay',
          cardNumber: "532 748 326 7238 842",
          status: 4,//不可用
          isDefault: 0,
        },
      ],
    };
  },
  components: {
    TabHistory,
    TabOrder,
    MakePayment,
    EditPay,
    DeleteCard,
    MakeDefault,
    AddMethod,
    Recharge,
  },
  watch:{
    $route: {
      handler(val, oldval) {
        if(val.query.type == 'order') {
          this.tabPosition=2;
          setTimeout(() => {
            if(this.$route.query.orderId != undefined){
              this.keyword = this.$route.query.orderId;
              this.search();
            }
          }, 500);
        }else {
          this.tabPosition=1;
        }
      },
      immediate: true,
      deep: true,
    },
      tabPosition:function (val) {
          this.date = '';
          this.keyword = '';
          this.$refs.order.start = '';
          this.$refs.order.end = '';
          this.$refs.log.start = '';
          this.$refs.log.end = '';
          this.$refs.log.keyword = '';
          this.$refs.order.keyword = '';
          if(val == 2 || val == '2'){
             this.$refs.order.getList();
             this.$refs.order.getType();
          }
          if(val == 1 || val == '1'){
              this.$refs.log.getList();
          }
      }
  },
  methods: {
    rechargeItem(){
      this.$refs.rechargeModal.getPayments();
      this.$refs.rechargeModal.showChange();
    },

    makePayment(card) {
      this.$refs.paymentmodal.getPayments();
      this.$refs.paymentmodal.selectCard(card);
      this.$refs.paymentmodal.showChange();
    },
    defaultPayment() {
      this.$refs.defaultmodla.showChange();
    },
    editPayment() {
      this.$refs.editmodal.showChange();
    },
    delPayment() {
      this.$refs.delmodal.showChange();
    },
    addPayment() {
      this.$refs.addmodal.showChange();
    },
    getUserMonthlyConsumption() {
      this.$http
        .post("/home/user/getUserMonthlyConsumption", {})
        .then((res) => {
          res = res.data.data;
          this.balance = res.balance;
          this.log_money = res.log_money;
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    search() {
      let start = "";
      let end = "";
      if (this.date) {
        for (var i = 0; i < 2; i++) {
          if (i == 0) {
            start = this.timeToString(this.date[0]);
          } else {
            end = this.timeToString(this.date[1]);
          }
        }
     }
      this.$refs.log.page = 1;
      this.$refs.log.size = 10;
      this.$refs.order.page = 1;
      this.$refs.order.size = 10;
      this.$refs.log.start = start;
      this.$refs.order.start = start;
      this.$refs.log.end = end;
      this.$refs.order.end = end;
      this.$refs.log.keyword = this.keyword;
      this.$refs.order.keyword = this.keyword;
      switch (this.tabPosition) {
          case 1:
          case '1':
              this.$refs.log.getList();
              break;
          case '2':
          case 2:
              this.$refs.order.getList();
              break;
      }
    },
    timeToString(obj) {
      var d = new Date(obj);
      return (
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds()
      );
    },
    download(){
        let start = "";
        let end = "";
        let keyword = this.keyword;
        if (this.date) {
            for (var i = 0; i < 2; i++) {
                if (i == 0) {
                    start = this.timeToString(this.date[0]);
                } else {
                    end = this.timeToString(this.date[1]);
                }
            }
        }
        url = process.env.YISU_API_URL+'/home/billing';
        switch (this.tabPosition) {
            case 1:
            case'1' :
                var url =url+'/getLogMoneyList';
                break;
            case '2':
            case 2:
              var url =url+'/getOrderList';
                break;
        }
        url = url + '?downLoad=1&'+'start='+start+'&end='+end+'&keyword='+keyword;
        window.open(url,'_blank') // 新窗口打开外链接
    },
    updateMoneyList() {
      this.$refs.log.getList();
    }
  },
  created() {
    this.getUserMonthlyConsumption();
  },
};
</script>

<style scoped lang="scss">
.dark {
  z-index: 1000;
}
.orange {
  color: #f7ba2a !important;
}
.billing-wrap {
  .consume-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 48px;
    .consume-item {
      width: calc((100% - 24px) / 2);
      height: 128px;
      border: 1px solid #e1e2e6;
      padding-top: 32px;
      position: relative;
      p {
        text-align: center;
        &:nth-child(1) {
          font-size: 32px;
          font-weight: 600;
          color: #0f1e33;
          line-height: 36px;
          margin-bottom: 8px;
        }
        &:nth-child(2) {
          font-size: 16px;
          font-weight: 500;
          color: #0f1e33;
          line-height: 16px;
        }
      }
      .addbtn {
        position: absolute;
        left: 80%;
        top: 50%;
        height: 40px;
        cursor: pointer;
        transform: translateY(-50%);
        color: #3377ff;
        font-size: 16px;
        line-height: 40px;
        font-weight: bold;
      }
    }
  }

  .payment-wrap {
    margin-bottom: 48px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: #0f1e33;
      line-height: 24px;
      margin-bottom: 24px;
    }
    .payment-list {
      width: 100%;
      padding: 32px 24px;
      border: 1px solid #e1e2e6;
      display: flex;
      flex-wrap: wrap;
      .payment-item {
        flex-shrink: 0;
        width: 750px;
        height: 80px;
        margin-right: 20px;
        border: 1px solid #dbe1e8;
        padding: 0 24px 0 40px;
        margin-bottom: 24px;
        display: inline-block;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .payment-left {
          display: flex;
          align-items: center;
          .imgbox {
            width: 80px;
            height: 40px;
            margin-right: 18px;
            background: linear-gradient(180deg, #ffffff 0%, #efefef 100%);
            border: 1px solid #cccccc;
            text-align: center;
            .icon {
              display: inline-block;
              width: 70px;
              height: 40px;
            }
          }

          .payment-card {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p {
              font-size: 16px;
              color: #2d3037;
            }
            ul {
              display: flex;
              li {
                color: #0f1e33;
                font-size: 14px;
                margin-right: 60px;
              }
              .cardExpires {
                margin-right: 20px;
              }
              .cardStatus {
                margin-left: 60px;
              }
              .orange {
                color: #f7ba2a;
              }
              .red {
                color: #F56C6C;
              }
              .green {
                color: #67C23A;
              }

            }
          }
        }
      }
      .locked-card {
        background: #E6EBF2;
        opacity: .3;
      }
       .default-payment{
        background: url(../../assets/images/method.png) no-repeat left top;
        position: relative;
        &::before{
          content:'Default';
          position: absolute;
          left: 0;
          top: 8px;
          color: #9EA7B3;
          font-size: 12px;
          transform: rotate(-32deg);
        }

      }
      .payment-item:hover {
        box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
      }
      .add {
        width: 100%;
        height: 48px;
        background: #ebf1ff;
        border: 1px solid #ebf1ff;
        color: #3377ff;
        font-size: 16px;
      }
    }
  }

  .billing-tab-head {
    .tab-tool {
      float: left;
    }
    .database-tab {
      float: right;
      .download {
        float: left;
        width: 48px;
        height: 48px;
        margin-left: 12px;
        button {
          width: 48px;
          height: 48px;
          padding: 0;
        }
      }
    }
  }
}
</style>
<style>
.billing-tab-head .tab-tool .el-radio-button__inner {
  min-width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/billing/Billing.vue